// Module generated from Markdown by Markdown Component Loader v1.1.0
import React from 'react';
import PropTypes from 'prop-types';

MarkdownComponent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

function MarkdownComponent(props) {
  const { className, style } = props;

  return (
    <div className={className} style={style}>
      <h3 id="april-20-2022">April 20, 2022</h3>
      <p>We added 2 new FHIR R4 resources that support READ and SEARCH functionality. These resources are:</p>
      <ul>
      <li><a href="https://www.hl7.org/fhir/medicationdispense.html">MedicationDispense</a></li>
      <li><a href="https://www.hl7.org/fhir/medicationrequest.html">MedicationRequest</a></li>
      </ul>
      <hr />
      <h3 id="august-16th-2021">August 16th, 2021</h3>
      <p>Launch of the Clinical Health API</p>
    </div>
  );
};

export default MarkdownComponent;
